/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { OutbOrd08Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const outbOrd08ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
});

export const outbOrd08FetchOutbOrd08Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const outbOrd08FetchOutbOrd08Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const outbOrd08AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const outbOrd08RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const outbOrd08SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const outbOrd08CreateOutbOrd08Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const outbOrd08CreateOutbOrd08Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

export const outbOrd08SetExpandedRows = (state, { expandedRows }) => ({
  ...state,
  expandedRows
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [OutbOrd08Types.OUTB_ORD08_RESET_TIMESTAMP]: outbOrd08ResetTimestamp,
  [OutbOrd08Types.OUTB_ORD08_FETCH_OUTB_ORD08_LOADING]: outbOrd08FetchOutbOrd08Loading,
  [OutbOrd08Types.OUTB_ORD08_FETCH_OUTB_ORD08_SUCCESS]: outbOrd08FetchOutbOrd08Success,
  [OutbOrd08Types.OUTB_ORD08_ADD_SELECTED_DOCUMENTS]: outbOrd08AddSelectedDocuments,
  [OutbOrd08Types.OUTB_ORD08_REMOVE_SELECTED_DOCUMENTS]: outbOrd08RemoveSelectedDocuments,
  [OutbOrd08Types.OUTB_ORD08_SET_WORKSPACE_VISIBLE]: outbOrd08SetWorkspaceVisible,
  [OutbOrd08Types.OUTB_ORD08_CREATE_OUTB_ORD08_LOADING]: outbOrd08CreateOutbOrd08Loading,
  [OutbOrd08Types.OUTB_ORD08_CREATE_OUTB_ORD08_SUCCESS]: outbOrd08CreateOutbOrd08Success,
  [OutbOrd08Types.OUTB_ORD08_SET_EXPANDED_ROWS]: outbOrd08SetExpandedRows
});
